import React from "react";
import { fieldErrorId } from "../../utils/helpers/formValidation";

export const RequiredMark = ({ optional = false }) =>
  optional ? null : <span className="akas-required-mark" aria-hidden="true">*</span>;

export const FieldFeedback = ({ formId = "akas-form", name, error, hint, showHint = false, className = "" }) => (
  <div className={`akas-field-feedback ${className}`.trim()}>
    {error ? (
      <div id={fieldErrorId(formId, name)} className="invalid-feedback d-flex align-items-start gap-1" role="alert">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 8v5M12 16.5v.01" />
        </svg>
        <span>{error}</span>
      </div>
    ) : showHint && hint ? (
      <div className="form-hint">{hint}</div>
    ) : null}
  </div>
);

export const FormValidationNotice = ({ errors, title = "Periksa kembali data yang ditandai.", showSummary = false }) => {
  const count = Object.keys(errors || {}).length;
  if (!showSummary || !count) return null;

  return (
    <div className="akas-validation-notice" role="alert" aria-live="polite">
      <span className="akas-validation-notice__icon">!</span>
      <span><strong>{title}</strong><small>{count} kolom belum sesuai.</small></span>
    </div>
  );
};
